var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { _PdfDecodeStream } from '../decode-stream';
var _PdfLempelZivWelchStream = /** @class */ (function (_super) {
    __extends(_PdfLempelZivWelchStream, _super);
    function _PdfLempelZivWelchStream(str, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = str;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange || 0,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for (var i = 0; i < 256; ++i) {
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        _this.lastCode = null;
        return _this;
    }
    _PdfLempelZivWelchStream.prototype.readBits = function (n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while (bitsCached < n) {
            var c = this.stream.getByte(); // eslint-disable-line
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = (cachedData << 8) | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        this.lastCode = null;
        return (cachedData >>> bitsCached) & ((1 << n) - 1);
    };
    _PdfLempelZivWelchStream.prototype.readBlock = function () {
        var blockSize = 512;
        var decodedSizeDelta = blockSize;
        var estimatedDecodedSize = blockSize * 2;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState; // eslint-disable-line
        if (!lzwState) {
            return;
        }
        var earlyChange = lzwState.earlyChange; // eslint-disable-line
        var nextCode = lzwState.nextCode; // eslint-disable-line
        var dictionaryValues = lzwState.dictionaryValues; // eslint-disable-line
        var dictionaryLengths = lzwState.dictionaryLengths; // eslint-disable-line
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes; // eslint-disable-line
        var codeLength = lzwState.codeLength; // eslint-disable-line
        var prevCode = lzwState.prevCode; // eslint-disable-line
        var currentSequence = lzwState.currentSequence; // eslint-disable-line
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize); // eslint-disable-line       
        for (i = 0; i < blockSize; i++) {
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (code === null) {
                break;
            }
            if (code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            }
            else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for (j = currentSequenceLength - 1, q = code; j >= 0; j--) {
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                }
                else {
                    currentSequence[currentSequenceLength++] = currentSequence[0];
                }
            }
            else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            }
            else {
                this.eof = true;
                this.lzwState = null;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength =
                    ((nextCode + earlyChange) & (nextCode + earlyChange - 1))
                        ? codeLength
                        : Math.min(((Math.log(nextCode + earlyChange) / 0.6931471805599453) + 1) | 0, 12);
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do {
                    estimatedDecodedSize += decodedSizeDelta;
                } while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for (j = 0; j < currentSequenceLength; j++) {
                buffer[currentBufferLength] = currentSequence[j];
                currentBufferLength++;
            }
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    return _PdfLempelZivWelchStream;
}(_PdfDecodeStream));
export { _PdfLempelZivWelchStream };
